<template>
  <div id="app">
    <div class="app__loading" v-if="!authStateChecked || dashboardNotRendered">
      <div class="app__loadingNavBar" v-if="userId">
        <NavBar />
      </div>
      <vue-loaders-line-scale color="#5e72e4" scale="1" class="app__loadingSpinner"></vue-loaders-line-scale>
    </div>
    <router-view v-if="authStateChecked" />
    <InProcess />
    <Errors />
    <notifications group="app" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import InProcess from '@/components/InProcess'
import Errors from '@/components/Errors'
// services
import db from '@/services/db'
// helpers
import utils from '@/helpers/utils/index.js'

export default {
  name: 'App',
  components: {
    InProcess,
    Errors
  },
  computed: {
    ...mapState([
      'authStateChecked',
      'userId',
      'caslRules',
      'dashboardNotRendered'
    ])
  },
  watch: {
    userId () {
      if (!this.userId) return
      db.access.admin(this.userId, (actions) => {
        if (actions) {
          let rule = this.$buildACLRule('Admin', actions)
          this.$store.commit('updateCaslRules', rule)
        }
      })
    },
    '$store.state.workflows'(nv) {
      //console.log(nv)
    },
  }
}
</script>

<style lang="scss">
@import '~$scss/fonts';
@import '~$scss/guideline';

#app {
  position: relative;
  width: 100%;
  font-smooth: always;
}

.app__loadingSpinner {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: white;
  img {
    width: 70px;
    height: 70px;
  }
}
.app__loadingNavBar {
  position: absolute;
  left: 0;
  top: 0;
  height: 38px;
  width: 100%;
  z-index: 1010;
}
</style>
